import React, { useState, useEffect } from 'react';
import AppHeader from './AppHeader';
import './VenueSelector.css';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

const VenueSelector = ({
  onVenueSelect, onCreateNew, onEditVenue, onBack,
  onGoToProfile, onGoToEventManagement, onGoToAdminPanel, onGoToQrScanner,
}) => {
  const [venues, setVenues]   = useState([]);
  const [loading, setLoading] = useState(true);

  const loadVenues = () => {
    fetch(`${API_BASE_URL}/api/venues`)
      .then(res => res.json())
      .then(data => { setVenues(data); setLoading(false); })
      .catch(() => setLoading(false));
  };

  useEffect(() => { loadVenues(); }, []);

  const handleDelete = async (venue, e) => {
    e.stopPropagation();
    if (!window.confirm(`"${venue.name}" salonunu silmek istediğinize emin misiniz?`)) return;
    try {
      await venues.delete(venue.id);
      alert('Salon silindi!');
      window.location.reload();
    } catch (err) {
      alert(err.message || 'Salon silinemedi!');
    }
  };

  const handleEdit = async (venue, e) => {
    e.stopPropagation();
    try {
      const res = await fetch(`${API_BASE_URL}/api/venues/${venue.id}`);
      if (res.ok) onEditVenue(venue);
    } catch (err) {
      if (err.message?.includes('Salon düzenlenemez')) {
        alert('Bu salon aktif bir etkinlikte kullanılıyor ve düzenlenemez!');
      } else {
        alert('Bir hata oluştu!');
      }
    }
  };

  if (loading) return <div className="loading"><i className="fa-solid fa-spinner fa-spin" /> Salonlar yükleniyor...</div>;

  return (
    <div className="venue-selector">
      <AppHeader
        title="Salon Yönetimi"
        onBack={onBack}
        onGoToProfile={onGoToProfile}
        onGoToEventManagement={onGoToEventManagement}
        onGoToAdminPanel={onGoToAdminPanel}
        onGoToQrScanner={onGoToQrScanner}
      />

      <div className="venue-info-bar">
        <span className="venue-info-count">Toplam {venues.length} salon bulundu</span>
        {onCreateNew && (
          <button onClick={onCreateNew} className="create-new-btn">
            <i className="fa-solid fa-plus" /> Yeni Salon
          </button>
        )}
      </div>

      <div className="venue-grid">
        {venues.length === 0 ? (
          <div className="no-venues">
            Henüz salon oluşturulmamış. Yeni salon oluşturmak için butona tıklayın.
          </div>
        ) : (
          venues.map(venue => (
            <div key={venue.id} className="venue-card" onClick={() => onVenueSelect(venue)}>
              {venue.mainPhoto && (
                <div className="venue-photo">
                  <img
                    src={`${API_BASE_URL}${venue.mainPhoto}`}
                    alt={venue.name}
                    onError={(e) => { e.target.style.display = 'none'; }}
                  />
                </div>
              )}

              {onEditVenue && (
                <div className="venue-actions">
                  <button className="edit-btn" onClick={(e) => handleEdit(venue, e)} title="Düzenle">
                    <i className="fa-solid fa-pen" />
                  </button>
                  <button className="delete-btn" onClick={(e) => handleDelete(venue, e)} title="Sil">
                    <i className="fa-solid fa-trash" />
                  </button>
                </div>
              )}

              <div className="venue-icon"><i className={`fa-solid ${getVenueIcon(venue.type)}`} /></div>
              <h3>{venue.name}</h3>
              <div className="venue-info">
                <span className="venue-type">{getVenueTypeName(venue.type)}</span>
                <span className="section-count">{venue.sections?.length || 0} Bölüm</span>
              </div>
              <div className="stage-position">Sahne: {getStagePositionName(venue.stagePosition)}</div>
              {venue.description && <p className="venue-description">{venue.description}</p>}
            </div>
          ))
        )}
      </div>
    </div>
  );
};

// FA ikon class'ları (string, fa-solid prefix ile kullanılır)
const getVenueIcon = (type) => ({
  0: 'fa-masks-theater',
  1: 'fa-guitar',
  2: 'fa-film',
  3: 'fa-trophy',
  4: 'fa-building-columns',
  5: 'fa-briefcase'
})[type] || 'fa-building';

const getVenueTypeName = (type) => ({ 0:'Tiyatro', 1:'Konser', 2:'Sinema', 3:'Stadyum', 4:'Arena', 5:'Konferans' })[type] || 'Diğer';
const getStagePositionName = (pos) => ({ 0:'Ön Taraf', 1:'Arka Taraf', 2:'Merkez', 3:'Sol Taraf', 4:'Sağ Taraf' })[pos] || 'Belirsiz';

export default VenueSelector;
